const TrainSeats = ({ classDetails, handleShow }) => {
  const seats = classDetails.seats;
  const isTrain = classDetails.class.type_class === 'Train';
  const coachImg  = classDetails.class.coach_image;
  const coachName = classDetails.class.coach_name;

  const getSeat = (num) => seats.find((s) => s.seat_number === num);

  const renderSeat = (num, style = {}) => {
    const s = getSeat(num);
    if (!s) return null;
    return (
      <div
        key={s.id}
        className={`bola-seat ${isTrain ? 'bola-roja' : ''} ${s.status === 1 ? 'ocupado' : ''}`}
        style={style}
        onClick={() => s.status !== 1 && handleShow(s.seat_number)}
      >
        <span>{s.seat_number}</span>
      </div>
    );
  };

  return (
    <div className="ride-grid-wrapper">
      <div className="ride-grid">

        {/* Row 1: [1][2][3][Coach][4][5][6] */}
        {renderSeat(1,  { gridColumn: 1, gridRow: 1 })}
        {renderSeat(2,  { gridColumn: 2, gridRow: 1 })}
        {renderSeat(3,  { gridColumn: 3, gridRow: 1 })}

        <div
          className={`bola-coach ${isTrain ? 'bola-roja' : ''}`}
          style={{ gridColumn: 4, gridRow: 1 }}
        >
          {coachImg ? (
            <img
              src={require(`../images/coaches/${coachImg}`)}
              alt={coachName}
              style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }}
            />
          ) : (
            <span className="name-coach">{coachName || 'Coach'}</span>
          )}
        </div>

        {renderSeat(4,  { gridColumn: 5, gridRow: 1 })}
        {renderSeat(5,  { gridColumn: 6, gridRow: 1 })}
        {renderSeat(6,  { gridColumn: 7, gridRow: 1 })}

        {/* Row 2: [ ][7][8][9][10][11][ ] */}
        <div style={{ gridColumn: 1, gridRow: 2 }} />
        {renderSeat(7,  { gridColumn: 2, gridRow: 2 })}
        {renderSeat(8,  { gridColumn: 3, gridRow: 2 })}
        {renderSeat(9,  { gridColumn: 4, gridRow: 2 })}
        {renderSeat(10, { gridColumn: 5, gridRow: 2 })}
        {renderSeat(11, { gridColumn: 6, gridRow: 2 })}
        <div style={{ gridColumn: 7, gridRow: 2 }} />

      </div>
    </div>
  );
};

export default TrainSeats;
